import { render } from "./action.sound.vue?vue&type=template&id=42eb4203"
import script from "./action.sound.vue?vue&type=script&lang=js"
export * from "./action.sound.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Development\\vue\\okraina.sbs.monitor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__